import { render, staticRenderFns } from "./ChartList.vue?vue&type=template&id=61c98d10&scoped=true&"
import script from "./ChartList.vue?vue&type=script&lang=js&"
export * from "./ChartList.vue?vue&type=script&lang=js&"
import style0 from "./ChartList.vue?vue&type=style&index=0&id=61c98d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c98d10",
  null
  
)

export default component.exports